<script lang="ts">
  import { isThemeDark, setTheme } from '#lib/utils/theme.svelte.js';
  import TimeRangeEnum, { type TimeRangeSettings } from './TimeRangeEnum.svelte';
  import SyncXRangeButton from './SyncXRangeButton.svelte';
  import Fa from 'svelte-fa';
  import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';

  interface Props {
    timeRangeSettings: TimeRangeSettings;
    showSyncXButton?: boolean;
    children?: import('svelte').Snippet;
  }

  let { timeRangeSettings, showSyncXButton, children }: Props = $props();
</script>

<menu class="flex flex-nowrap items-center gap-2 bg-sky-600 px-4 text-white dark:bg-slate-700">
  <TimeRangeEnum {timeRangeSettings} />
  {#if showSyncXButton}
    <SyncXRangeButton />
  {/if}
  {@render children?.()}
  <label class="toggle toggle-lg bg-base-300 ml-auto border-0">
    <input
      type="checkbox"
      bind:checked={() => !isThemeDark(), (v) => setTheme(!v ? 'chartium-dark' : 'chartium-light')}
    />
    <Fa icon={faMoon} class="m-auto" />
    <Fa icon={faSun} class="m-auto" />
  </label>
</menu>
